import React, { useState } from 'react';
import { BankAccountBox, TextBoxLayoutStyle } from '@apply/components';
import { sectionHeaderStyle } from '../constants/styles';

export const BankAccountBoxPanel: React.FC = () => {
    const [bankAccountNumber, set_bankAccountNumber] = useState('');

    return (
        <>
            <h6 style={sectionHeaderStyle}>Bank Account Components:</h6>
            <div style={{ marginBottom: '1rem' }}>
                <BankAccountBox
                    value={bankAccountNumber}
                    label='Bank Account (Last 4 Digits)'
                    onChange={set_bankAccountNumber}
                    width='100%'
                    maxLength={4}
                />
            </div>

            <div style={{ marginBottom: '1rem' }}>
                <BankAccountBox
                    value={bankAccountNumber}
                    label='Bank Account (Last 4 Digits)'
                    onChange={set_bankAccountNumber}
                    width='100%'
                    maxLength={4}
                    showInfoIcon={true}
                    infoText='Bank Account with 4 digits'
                />
            </div>
            <div style={{ marginBottom: '1rem' }}>
                <BankAccountBox
                    value={bankAccountNumber}
                    label='Bank Account (Last 4 Digits) (Horiz.)'
                    onChange={set_bankAccountNumber}
                    width='100%'
                    maxLength={4}
                    layoutStyle={TextBoxLayoutStyle.Horizontal}
                    labelWidth='230px'
                />
            </div>
            <div style={{ marginBottom: '1rem' }}>
                <BankAccountBox
                    value={bankAccountNumber}
                    label='Bank Account (Last 4 Digits) (Horiz.)'
                    onChange={set_bankAccountNumber}
                    width='100%'
                    maxLength={4}
                    showInfoIcon={true}
                    infoText='Bank Account with 4 digits'
                    layoutStyle={TextBoxLayoutStyle.Horizontal}
                    labelWidth='270px'
                />
            </div>
        </>
    );
};
